<script>
import {ConcernElements} from "@/views/product/components/product-card";
export default {
    props: {
        legislations: {
            required: true
        },
        section: {
            required: true,
        },
    },
    components: {ConcernElements},
    computed: {
        substanceListsTableLegislations() {
            return this.legislations.map(l => l.id);
        },
        excludedSubstances() {
            return this.section.excluded.map(id => {
                return {substance: {id}};
            });
        }
    }
}
</script>

<template>
        <ConcernElements
            :product="{}"
            :show-information-owner-settings="false"
            :company-has-information="true"
            :legislations="substanceListsTableLegislations"
            :show-instruction="false"
            :show-substance-list-instruction="false"
            :show-no-single-parts-checkbox="false"
            :show-questions="false"
            :auto-expand-lists="legislations.length === 1"
            :auto-expand-substances="legislations.length === 1"
            :read-only="true"
            container-class=""
            :included-substances="section.included"
            :excluded-substances="excludedSubstances"
        />
</template>

<style scoped lang="scss">

</style>
